import Transaction from "@/classes/Transaction.ts";

export default class Expense extends Transaction {
  type: "expense" = "expense";
}
